import { Form, Formik } from 'formik'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'
import * as Yup from 'yup'
import FullPageLoading from 'components/FullPageLoading'
import Button from 'components/Button'
import { useEventSlug } from 'hooks'
import { _, withCapture } from 'utils'
import TextField from '../forms/components/TextField'
import { inviteAdmin } from './graphql/mutation'
import { showErrorNotification, showNotification } from '../notifications/notificationsSlice'

const S = {
    TextField: styled(TextField)`
        width: calc(100% + 20px);
        margin: 0 -10px 40px -10px;
    `,
    Actions: styled.div`
        width: 100%;
        display: flex;
        justify-content: flex-end;
    `
}

const InviteEmailValidation = Yup.object().shape({
    email: Yup.string().email().required(),
})

interface Props {
    close: () => void
    callGetAdmins: () => Promise<void>
}

const InviteAdminModal = ({ close, callGetAdmins }: Props) => {
    const [isUploading, setIsUploading] = useState(false)
    const eventSlug = useEventSlug()
    const dispatch = useDispatch()
    const handleSubmit = withCapture(async (values) => {
        setIsUploading(true)
        const response = await inviteAdmin(eventSlug, values.email)
        setIsUploading(false)
        close()

        if (!response.data || response.errors.length) {
            dispatch(showErrorNotification(response.errors))
            return
        }
        dispatch(showNotification({
            type: 'success',
            body: _('form.notification.create_success'),
        }))

        callGetAdmins()
    })

    return (
        <Formik
            initialValues={{ email: '' }}
            validationSchema={InviteEmailValidation}
            onSubmit={handleSubmit}
        >
            <>
                <Form>
                    <S.TextField
                        name="email"
                        label={_('event_admins.form.email')}
                        isRequired
                    />
                    <S.Actions>
                        <Button variant="secondary" style={{ marginRight: 10 }} onClick={close}>
                            {_('button.cancel')}
                        </Button>
                        <Button variant="success" type="submit">
                            {_('event_admins.form.send_invitation_button')}
                        </Button>
                    </S.Actions>
                </Form>
                {isUploading && <FullPageLoading isAbsolute fullWidth />}
            </>
        </Formik>
    )
}

export default InviteAdminModal
